<template>
    <div class="orderManagementClass">
        <div class="orderManagementContent" :style="contentViewHeight">
            <div class="printOrderListBox">
                <div>
                    <div class="orderSearchBox">
                        <div class="searchItem">
                            <div class="name">姓名</div>
                            <el-input v-model="activityName" placeholder="姓名"></el-input>
                        </div>
                        <div class="searchItem">
                            <div class="name">活动名称</div>
                            <el-input v-model="activityUserName" placeholder="活动名称"></el-input>
                        </div>
                        <el-button class="searchBtn" @click="search">添加</el-button>
                        <el-button type="text" class="resetBtn" @click="resetData">
                            <i class="iconfont icon-qingchushujuku"></i>
                            <span>清除条件</span>
                        </el-button>
                    </div>
                    <div class="orderListTable">
                        <div class="tableTool">
                            <div class="toolRight">
                                <el-button type="primary" size="small" @click="toDialog('add')"><i
                                    class="el-icon-circle-plus-outline"></i>新增
                                </el-button>
                            </div>
                        </div>
                        <el-table
                            :data="tableData"
                            border
                            style="width: 100%" class="tableContent">
                            <el-table-column
                                prop="nickname"
                                label="用户昵称"
                                header-align="center"
                                align="center"
                                show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                prop="name"
                                label="姓名"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="gender"
                                align="center"
                                header-align="center"
                                label="性别">
                            </el-table-column>
                            <el-table-column
                                prop="activeName"
                                align="center"
                                header-align="center"
                                label="活动名称">
                            </el-table-column>
                            <el-table-column
                                prop="worksClass"
                                align="center"
                                header-align="center"
                                label="作品分类">
                            </el-table-column>
                            <el-table-column
                                prop="telephone"
                                align="center"
                                header-align="center"
                                label="联系电话">
                            </el-table-column>
                            <el-table-column
                                label="操作"
                                header-align="center"
                                align="center">
                                <template slot-scope="scope">
                                    <!-- <el-button type="text" size="small">新增</el-button> -->
                                    <el-button type="text" size="small">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            background
                            @current-change="handleCurrentChange"
                            @prev-click="handleCurrentChange"
                            @next-click="handleCurrentChange"
                            layout="total,prev, pager, next,jumper"
                            :current-page="current"
                            :page-size="pageSize"
                            :total="total" class="pagination">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        
        <!--编辑/新增-->
        <management-dialog ref="activityManagementDialogRef"></management-dialog>

    </div>
</template>

<script>
    import managementDialog from './managementDialog'
    export default {
        components: {managementDialog},
        data() {
            return {
                activityName: '',
                activityUserName:'',
                tableData: [
                    {
                        uuid: '0',
                        nickname: '我是昵称',
                        name: '我是姓名',
                        gender: '男',
                        telephone: '7439823479',
                        activeName: '活动名称',
                        worksClass: '作品分类'
                    },
                    {
                        uuid: '1',
                        nickname: '我是昵称',
                        name: '我是姓名',
                        gender: '女',
                        telephone: '7439823479',
                        activeName: '活动名称',
                        worksClass: '作品分类'
                    },
                ],
                current: 1,
                pageSize: 10,
                total: 0,
            }
        },
        computed: {
            contentViewHeight() {
                let height = document.documentElement.clientHeight - 120
                return {minHeight: height + 'px'}
            },
        },
        created() {},
        methods: {
            resetData(){
                this.activityName = ''
                this.activityUserName = ''
            },
            // 分页
            handleCurrentChange(val){
                this.current = val
            },
            search(){
               this.current = 1
            },
            // 新增
            toDialog(type){
                this.$refs.activityManagementDialogRef.init(type)
            }
        }
    }
</script>

<style scoped lang="less">
    .orderManagementClass {
        position: relative;
        width: 100%;
        padding: 0 20px 20px;
        .orderManagementContent {
            background: #fff;
            .printOrderListBox {
                padding: 20px;
                .orderSearchBox {
                    display: flex;
                    flex-wrap: wrap;
        
                    /deep/ .el-input {
                        width: initial;
                        margin-right: 30px;
                    }
        
                    /deep/ .el-input__inner {
                        width: 242px;
                        height: 35px;
                        min-height: 35px;
                        font-size: 12px;
                        color: #999999;
                        background-color: #f2f4f7;
                        border: 1px solid #f2f4f7;
                        border-radius: 5px;
            
                        &:hover,
                        &:focus {
                            background-color: #fff;
                            border: 1px solid #108ee9;
                        }
                    }
        
                    /deep/ .el-input__prefix {
                        top: -3px;
                    }
        
                    /deep/ .el-input__suffix {
                        top: 2px;
                    }
        
                    /deep/ .el-button {
                        display: block;
                        line-height: 35px;
                        padding: 0;
                        height: 35px;
                    }
        
                    .searchBtn {
                        width: 82px;
                        background: #3d7fff;
                        border: none;
                        border-radius: 15px;
                        font-size: 14px;
                        color: #ffffff;
                    }
        
                    .resetBtn {
                        color: #333333;
                    }
                    .searchItem {
                        display: flex;
                        align-items: center;
                        margin-bottom: 20px;
                        // margin-right: 30px;

                        .name {
                            padding-right: 20px;
                            min-width: 100px;
                        }
                    }
                }
                
                .tableContent {
                    min-height: 650px;
                    
                    /deep/ .el-table__header {
                        tr {
                            th {
                                border-right: none;
                            }
                        }
                        
                        /deep/ .el-table__cell {
                            padding: 5px 0;
                            background: #f2f5fc;
                        }
                    }
                    
                    /deep/ .el-table__body {
                        img {
                            vertical-align: middle;
                            width: 52px;
                            height: 50px;
                        }
                    }
                }
                
                .pagination {
                    margin-top: 20px;
                    text-align: right;
                }
            }
        }
        .tableTool {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-bottom: 20px;
            .toolRight {
                button {
                    width: 83px;
                    height: 30px;
                    background: rgba(21, 126, 251, 1);
                    border: none;
                    border-radius: 15px;
                    font-size: 13px;
                    color: #fff;
                
                    i {
                        padding-right: 5px;
                    }
                
                    &:hover {
                        background: #61a2f0;
                    }
                }
            }
        }
        .dialogBox{
            .details{
                .detailsItem{
                    padding-bottom: 20px;
                    h3{
                        font-weight: 700;
                        font-size: 16px;
                        color: #000;
                        margin-top: 0;
                        letter-spacing: 1px;
                        border-bottom: 1px solid #ddd;
                        padding-bottom: 15px;
                    }
                    .itemContent{
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        padding: 0 30px;
                        .one-row{
                            width: 50%;
                            margin-bottom: 22px;
                            display: flex;
                            .label{
                                padding-right: 15px;
                                min-width: 95px;
                            }
                            .name{
                                color: #000;
                            }
                        }
                        .two-row{
                            width: 100%;
                            margin-bottom: 22px;
                            display: flex;
                            .label{
                                padding-right: 15px;
                                min-width: 95px;
                            }
                            .name{
                                color: #000;
                            }
                        }
                    }
                    .itemPictureContent{
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        padding: 0 30px;
                        justify-content: space-between;
                        .one-row{
                            width: 30%;
                            margin-bottom: 22px;
                            img{
                                width: 100%;
                                height: 138px;
                                border: 1px solid #ddd;
                            }
                            .name{
                                text-align: center;
                                padding-top: 10px;
                                font-size: 14px;
                                display: flex;
                                .label{
                                    min-width: 80px;
                                }
                            }
                        }
                    }
                }
            }
            .audit{
                padding-bottom: 20px;
                h3{
                    font-weight: 700;
                    font-size: 16px;
                    color: #000;
                    margin-top: 0;
                    letter-spacing: 1px;
                    border-bottom: 1px solid #ddd;
                    padding-bottom: 15px;
                }
                .auditContent{
                    padding: 0 30px;
                }
                .cause{
                    display: flex;
                    margin-top: 20px;
                    .causeTitle{
                        min-width: 80px;
                        color: #3a8ee6;
                    }
                    .causeContent{
                        color: #000;
                    }
                }
                .auditEnter{
                    text-align: center;
                    padding-top: 20px;
                    button{
                        width: 120px;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/judgesManagementList.vue